
import { httpRequest } from "../../../utils/HttpRequest";
import { IStockOutputField, IStockOutputSearch, IStockOutputDetail } from "./stockOutputType"
class StockOutputService {
    async page(searchVo: IStockOutputSearch) {
        const apiUrl = "/zzw-vrm/stockIo/out/findPage";
        return await httpRequest.post<IStockOutputDetail[]>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/stockIo/findById/${id}`;
        return await httpRequest.get<IStockOutputField>(apiUrl);
    }
    //导出
    async export(params: IStockOutputSearch) {
        const apiUrl = "/zzw-vrm/stockIo/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
}

export const stockOutputService = new StockOutputService();